<template>
  <div id="app" :class="appClasses">
    <div class="particles" v-if="!unlocked || listening"></div>
    <router-view v-if="unlocked" class="fade-in"/>
  </div>
</template>

<script>

const sequPassword = localStorage.getItem('sequPassword');

export default {
  name: 'App',
  data() {
    return {
      listening: false,
      unlocked: false,
      pressedKeys: [],
      hiddenTimestamp: 0
    };
  },
  methods: {
    unlock() {
      this.unlocked = true;
      setTimeout(() => {
        this.listening = false;
        this.pressedKeys = [];
      }, 500);
    },
    handleKeydown(event) {
      if (this.unlocked) return;
      
      if (!sequPassword) return;

      if (this.listening) {
        this.pressedKeys.push(event.key);

        if (this.pressedKeys.join('') === sequPassword.replace(/\D/g, '')) {
          this.unlock();
        }
      } else if (!this.unlocked && !this.listening) {

        if (event.ctrlKey && event.shiftKey && event.key === 'H') {
          this.listening = true;
          this.pressedKeys = [];
        }
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.listening = false;
        this.unlocked = false;
        this.pressedKeys = [];
      }
    }
  },
  computed: {
    appClasses() {
      if (this.unlocked) return 'unlocked';
      return this.listening ? 'listening' : 'locked';
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
};
</script>

<style>
html,body {
  margin: 0;
  padding: 0;
}
* {
  user-select: none;
  font-family: 'Inconsolata', monospace;
  font-family: 'Poppins', sans-serif;
}
textarea, select, input, button { outline: none; }

button {
  border: none;
  background-color: rgb(230, 230, 230);
  padding: 5px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: 200ms;
}

button:hover {
  background-color: rgb(168, 168, 168);
  transition: 200ms;
}

input:not([type=color]) {
  border: none;
  background-color: rgb(230, 230, 230);
  padding: 5px 10px;
  border-radius: 10px;
  transition: 200ms;

}

input[type=color] {
  border: none;
  cursor: pointer;
}

.fade-in {
  animation: fadeIn 200ms 1;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity:  1; }
}

.move-in-up {
  animation: move-in-up 200ms 1;
}

@keyframes move-in-up {
  0% {
    transform: translate(0, -100%);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0);
    opacity: 1
  }
}

/* Panel */

.container {
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
}

.panel {
  width: 300px;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.44);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.44);
  padding: 10px;
  border-radius: 6px;
}

.submit {
  display: flex;
  justify-content: center;

}

/* Forms */
.field {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.field > .label {

}

.field >  {

}

/* Flexbox */

.center {
  justify-content: center;
}

/* More buttons */


.round-button {
  padding: 0;
  margin: 0;

  height: 30px;
  width: 30px;

  border-radius: 50%;

  transition: 200ms;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  -webkit-box-shadow: 0px 0px 5px 0px rgb(0, 0, 0);
  box-shadow: 0px 0px 5px 0px rgb(0, 0, 0);
}

.round-button:hover {
  transition: 200ms;

  transform: scale(1.15);
}

.round-button:disabled {
  opacity: .7;
  cursor: not-allowed;
}

.round-button:disabled:hover {
  transform: scale(1);
}

/* Statics */

.transition-300 {
  transition: 1s;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: rgb(117, 117, 117);
  border-radius: 20px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(180, 180, 180);
  border-radius: 20px;
}

/* Keyframes */

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


/* Locking */

#app.locked {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1b1b1b, #000);
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  overflow: hidden;
  position: relative;
  z-index: 0;
  transition: background 1s ease-in-out;
  background: linear-gradient(120deg, #1b1b1b, #000);
  animation: lockedBackground 5s infinite;
}

#app.listening {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1b1b1b, #000);
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  overflow: hidden;
  position: relative;
  z-index: 0;
  transition: background 1s ease-in-out;
  background: linear-gradient(135deg, #8800ff, #24acb6, #158d91);
  animation: listeningBackground 3s infinite;
}

#app.unlocked {
  background: linear-gradient(to top, #8800ff, #24acb6);
  transition: background 1s ease-in-out;
}

.particles {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(rgba(255, 255, 255, 0.1), transparent);
  animation: sparkle 3s infinite;
  z-index: 1;
}

@keyframes lockedBackground {
  0%, 100% { background-position: 0% 0%; }
  50% { background-position: 100% 100%; }
}

@keyframes listeningBackground {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes sparkle {
  0%, 100% { opacity: 0.2; transform: rotate(0deg) scale(1); }
  50% { opacity: 0.6; transform: rotate(360deg) scale(1.2); }
}

.fade-in {
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

</style>



// WEBPACK FOOTER //
// src/App.vue